/**
 * Parse CSV text into headers + rows.
 * Handles quoted fields with commas and newlines.
 */
export function parseCsv(text: string): { headers: string[]; rows: string[][] } {
  const lines: string[][] = []
  let current: string[] = []
  let field = ''
  let inQuotes = false

  for (let i = 0; i < text.length; i++) {
    const ch = text[i]
    const next = text[i + 1]

    if (inQuotes) {
      if (ch === '"' && next === '"') {
        field += '"'
        i++
      } else if (ch === '"') {
        inQuotes = false
      } else {
        field += ch
      }
    } else {
      if (ch === '"') {
        inQuotes = true
      } else if (ch === ',') {
        current.push(field.trim())
        field = ''
      } else if (ch === '\r' && next === '\n') {
        current.push(field.trim())
        if (current.some(c => c !== '')) lines.push(current)
        current = []
        field = ''
        i++
      } else if (ch === '\n') {
        current.push(field.trim())
        if (current.some(c => c !== '')) lines.push(current)
        current = []
        field = ''
      } else {
        field += ch
      }
    }
  }

  // Last field/line
  current.push(field.trim())
  if (current.some(c => c !== '')) lines.push(current)

  if (lines.length === 0) return { headers: [], rows: [] }

  const headers = lines[0]!
  const rows = lines.slice(1)

  return { headers, rows }
}

/**
 * Read a File as text (CSV) or parse XLSX via simple TSV conversion.
 */
export async function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = () => reject(new Error('Failed to read file'))
    reader.readAsText(file)
  })
}
